import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './checkin-passenger-input-result.actions';
import { CheckinPassengerInputResultState } from './checkin-passenger-input-result.state';

/**
 * checkinPassengerInputResult initial state
 */
export const checkinPassengerInputResultInitialState: CheckinPassengerInputResultState = {
  requestIds: [],
};

/**
 * List of basic actions for CheckinPassengerInputResult Store
 */
export const checkinPassengerInputResultReducerFeatures: ReducerTypes<
  CheckinPassengerInputResultState,
  ActionCreator[]
>[] = [
  on(actions.setCheckinPassengerInputResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCheckinPassengerInputResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCheckinPassengerInputResult, () => checkinPassengerInputResultInitialState),

  on(actions.cancelCheckinPassengerInputResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCheckinPassengerInputResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setCheckinPassengerInputResultFromApi,
    actions.updateCheckinPassengerInputResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CheckinPassengerInputResult Store reducer
 */
export const checkinPassengerInputResultReducer = createReducer(
  checkinPassengerInputResultInitialState,
  ...checkinPassengerInputResultReducerFeatures
);
